module.exports = __webpack_public_path__ + "./fonts/loading_blue.3051c6b3ad099b25c6fa98f736cad8c0.svg";